import {Injectable} from '@angular/core';
import {MessageType, SubscriptionMessage, SubscriptionTopic, WebSocketResponse} from '../../types/websocket.types';
import {TradingWsService} from "./trading-ws.service";
import {filter} from "rxjs/operators";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class BadgeNotificationWsService {
  messages: Subject<WebSocketResponse>;

  constructor(private tradingWSService: TradingWsService) {
    this.messages = new Subject<WebSocketResponse>();
  }

  initConnection() {
    this.tradingWSService.initConnection();
    this.subscribe();
  }

  subscribe() {
    const subscription:SubscriptionMessage = {
      type: 'subscribe',
      topic: SubscriptionTopic.BADGE_NOTIFICATION,
    };
    this.tradingWSService.subscribe(subscription);
    this.tradingWSService.messages
      .pipe(filter(x => x.type == MessageType.BADGE_NOTIFICATION))
      .subscribe(message => this.messages.next(message));
  }

  destroyConnection() {
    this.tradingWSService.destroyConnection();
  }

  getDisconnectionSubject(): BehaviorSubject<boolean> {
    return this.tradingWSService.getDisconnectionSubject();
  }

  getReconnectModalSubject(): BehaviorSubject<boolean> {
    return this.tradingWSService.getDisconnectionSubject();
  }
}
